import { Button } from "@material-ui/core";
import React, { Component } from "react";
// import get from "lodash/get";
import DynamicForm from "../../../../../../../Component/DynamicForm";
import { checkboxinputconverter } from "../../../../../../../Component/DynamicForm/Fields/CheckBox";
import { dateinputconverter } from "../../../../../../../Component/DynamicForm/Fields/Date";
// import { instance } from "../../../../../../../Actions/AxiosInstance";
import { selectinputconverter } from "../../../../../../../Component/DynamicForm/Fields/Select";
import DrawerHeader from "../../../../../../../Component/Headers/drawerHeader";
import { convertDateForBackend } from "../../../../../../../Utils";
import { getOptArr } from "../../../../../../../Utils/arr";
import { instance } from "../../../../../../../Actions/AxiosInstance";
import { ErrorMessages } from "../../../../../../../Constants";

export default class AssignForm extends Component {
  state = {
    postdata: this.props.editdata || POST_DATA,
  };

  updatepostdata = (key, value) => {
    this.setState({
      postdata: {
        ...this.state.postdata,
        [key]: value,
      },
    });
  };

  onSave = () => {
    const { postdata, ispayslip, isform16 } = this.state;
    const isdouble = ispayslip && isform16;
    const { signingauthorityid, effectivefrom, fallbackforid } = postdata;
    if (!signingauthorityid) {
      this.props.enqueueSnackbar("Please select signing authority", {
        variant: "error",
      });
      return;
    } else if (!(ispayslip || isform16)) {
      this.props.enqueueSnackbar("Please select either Pay slip or Form16", {
        variant: "error",
      });
      return;
    } else if (!effectivefrom) {
      this.props.enqueueSnackbar("Please add effective from date", {
        variant: "error",
      });
      return;
    } else if (signingauthorityid == fallbackforid) {
      this.props.enqueueSnackbar(
        "Fallback cannot be same as signing authority",
        { variant: "error" },
      );
      return;
    }
    const senddata = {
      assigndata: isdouble
        ? [1, 2].map((x) => ({
            ...postdata,
            authorizedforid: x,
            effectivefrom: convertDateForBackend(postdata.effectivefrom),
          }))
        : [
            {
              ...postdata,
              authorizedforid: (ispayslip && 1) || (isform16 && 2),
              effectivefrom: convertDateForBackend(postdata.effectivefrom),
            },
          ],
    };
    console.log("senddata: ", senddata);
    instance
      .post("payroll/assignauthority", senddata)
      .then(() => {
        this.props.enqueueSnackbar(ErrorMessages.E0000, { variant: "success" });
        this.props.GetAllSigningAuthority();
        this.props.onCloseDrawer();
        this.props.gettimeline();
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  };

  render() {
    const { allsigningauthority = [] } = this.props;
    const { postdata, ispayslip, isform16 } = this.state;
    const { effectivefrom, signingauthorityid, fallbackforid } = postdata;
    // return <div>Assignment Form {get(postdata, "effectivefrom", "")}</div>;
    return (
      <div className="planner-right-drawer">
        <div className="inner-wrapper opaque">
          <DrawerHeader
            header="Assign authority"
            closeDrawer={this.props.onCloseDrawer}
          />
          <DynamicForm
            fields={dateinputconverter({
              value: effectivefrom,
              label: "effective from",
            })}
            onChange={(val) => this.updatepostdata("effectivefrom", val)}
          />
          <DynamicForm
            fields={selectinputconverter({
              label: "Select signing authority",
              options: getOptArr({
                arr: allsigningauthority,
                displaynamekey: "employeefullname",
                displayvaluekey: "signingauthorityid",
              }),
              value: signingauthorityid,
            })}
            onChange={(val) => this.updatepostdata("signingauthorityid", val)}
          />
          <DynamicForm
            fields={selectinputconverter({
              label: "Select fallback (Optional)",
              options: getOptArr({
                arr: allsigningauthority.filter(
                  (x) => x.signingauthorityid != signingauthorityid,
                ),
                displaynamekey: "employeefullname",
                displayvaluekey: "signingauthorityid",
              }),
              value: fallbackforid,
            })}
            onChange={(val) => this.updatepostdata("fallbackforid", val)}
          />
          <DynamicForm
            fields={checkboxinputconverter({
              value: ispayslip,
              label: "Pay slip",
            })}
            onChange={() => this.setState({ ispayslip: !ispayslip })}
          />
          <DynamicForm
            fields={checkboxinputconverter({
              value: isform16,
              label: "Form 16",
            })}
            onChange={() => this.setState({ isform16: !isform16 })}
          />
          <div className="margin-top-20">
            <Button className="btn btn-primary-sm-blue" onClick={this.onSave}>
              Save
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

const POST_DATA = {
  authoritydetailid: null, // null,
  signingauthorityid: null, // 2,
  authorizedforid: null, // 1,
  effectivefrom: null, // "2019-01-01",
  fallbackforid: null, // null,
  isdefault: true, // true
};

/*
const POST_DATA = {
    "assigndata" : [
        {
          "authoritydetailid": null,
          "signingauthorityid": 2,
          "authorizedforid": 1, //payslip 1, form16: 2,  // 2 obj
          "effectivefrom": "2019-01-01",
          "fallbackforid": null, // always signingauthorityid
          "isdefault": true,  // Default
        }
     ]
};
*/
